var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfusiveMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 40,
    viewBox: "0 0 73 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.44V0.700001H2.02V14.44H0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2386 3.86C12.5186 3.86 14.1186 5.52 14.1186 7.86V14.44H12.1786V8.2C12.1786 6.66 11.1986 5.58 9.79859 5.58C8.35859 5.58 7.11859 6.52 6.95859 7.74V14.44H4.97859V4.1H6.95859V5.6C7.57859 4.58 8.83859 3.86 10.2386 3.86Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6712 2.96V4.1H22.1112V5.78H19.6712V14.44H17.7313V5.78H16.1712V4.1H17.7313V2.86C17.7313 1.2 18.8512 0.0400007 20.4513 0.0400007C21.1912 0.0400007 21.9513 0.320001 22.5112 0.780001L21.7913 2.1C21.5713 1.88 21.1713 1.72 20.7313 1.72C20.1513 1.72 19.6712 2.24 19.6712 2.96Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2783 4.1H33.2583V14.44H31.2783V12.94C30.6583 13.96 29.3983 14.68 27.9983 14.68C25.7183 14.68 24.1183 13.02 24.1183 10.68V4.1H26.0583V10.34C26.0583 11.88 27.0383 12.96 28.4383 12.96C29.8783 12.96 31.1183 12.02 31.2783 10.8V4.1Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8709 14.68C38.3509 14.68 36.6909 14.14 35.4509 13.14L36.3909 11.72C37.4909 12.52 38.6709 12.98 39.8909 12.98C41.0509 12.98 41.8509 12.44 41.8509 11.64C41.8509 10.68 40.7909 10.38 39.5109 10.02C37.1309 9.36 35.9509 8.68 35.9509 7C35.9309 5.1 37.5109 3.86 39.7109 3.86C41.0509 3.86 42.4109 4.32 43.5309 5.06L42.6509 6.52C41.6509 5.9 40.6109 5.56 39.7109 5.56C38.6909 5.56 37.8909 6 37.8909 6.78C37.8909 7.58 38.5309 7.82 40.2709 8.36C41.9709 8.86 43.7909 9.42 43.7909 11.48C43.7909 13.44 42.1309 14.68 39.8709 14.68Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0719 2.38C46.3919 2.38 45.8719 1.82 45.8719 1.18C45.8719 0.560001 46.3919 0 47.0719 0C47.7119 0 48.2519 0.560001 48.2519 1.18C48.2519 1.82 47.7119 2.38 47.0719 2.38ZM46.0719 14.44V4.1H48.0519V14.44H46.0719Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3561 14.44L49.9161 4.1H52.0561L55.2761 12.14L58.4361 4.1H60.5761L56.2161 14.44H54.3561Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5155 12.92C67.5955 12.92 68.8555 12.44 69.4755 11.8L70.7155 13.08C69.7955 14.06 67.9955 14.68 66.5355 14.68C63.6555 14.68 61.2155 12.42 61.2155 9.24C61.2155 6.14 63.5155 3.86 66.3755 3.86C69.5355 3.86 71.3555 6.26 71.3555 9.96H63.2155C63.4755 11.68 64.7355 12.92 66.5155 12.92ZM66.4555 5.62C64.8555 5.62 63.5555 6.7 63.2355 8.38H69.4355C69.2155 6.78 68.2355 5.62 66.4555 5.62Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.155 39.44V22.265H4.43L9.38 31.215L14.33 22.265H18.605V39.44H14.33V29.49L9.38 38.44L4.43 29.49V39.44H0.155Z",
    fill: "url(#paint0_linear_2_676)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8818 36.315C28.8818 36.315 30.0318 35.89 30.8068 35.215L33.3068 37.74C32.1568 38.915 29.9318 39.74 28.0068 39.74C24.0068 39.74 21.0568 36.915 21.0568 32.94C21.0568 29.015 23.9068 26.215 27.8068 26.215C31.9068 26.215 34.3068 29.215 34.3068 34.14H25.0818C25.4818 35.44 26.5068 36.315 27.8818 36.315ZM27.8818 29.615C26.6068 29.615 25.5818 30.365 25.1318 31.565H30.3818C30.0318 30.39 29.1568 29.615 27.8818 29.615Z",
    fill: "url(#paint1_linear_2_676)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0767 21.965H50.3267V39.44H46.0767V37.79C45.0517 39.015 43.5767 39.74 41.8517 39.74C38.3767 39.74 35.9267 36.94 35.9267 32.965C35.9267 29.015 38.3767 26.215 41.8517 26.215C43.5767 26.215 45.0517 26.94 46.0767 28.165V21.965ZM43.1267 36.215C44.8767 36.215 46.0767 34.865 46.0767 32.965C46.0767 31.09 44.8767 29.74 43.1267 29.74C41.3017 29.74 40.0017 31.09 40.0017 32.965C40.0017 34.865 41.3017 36.215 43.1267 36.215Z",
    fill: "url(#paint2_linear_2_676)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3765 24.94C54.1265 24.94 53.1265 23.915 53.1265 22.69C53.1265 21.515 54.1265 20.49 55.3765 20.49C56.6015 20.49 57.5765 21.515 57.5765 22.69C57.5765 23.915 56.6015 24.94 55.3765 24.94ZM53.2265 39.44V26.515H57.4515V39.44H53.2265Z",
    fill: "url(#paint3_linear_2_676)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4036 26.215C69.7286 26.215 72.2286 28.315 72.2286 31.765V39.44H68.1536V38.34C67.2536 39.24 65.9036 39.74 64.5786 39.74C61.8286 39.74 59.6536 38.065 59.6536 35.615C59.6536 33.09 62.0786 31.315 65.1286 31.315C66.0786 31.315 67.1536 31.54 68.1536 31.94V31.765C68.1536 30.39 67.1036 29.39 65.3286 29.39C64.1036 29.39 63.1786 29.765 62.0786 30.34L60.7536 27.69C62.5536 26.79 64.4036 26.215 66.4036 26.215ZM65.6036 37.14C66.8536 37.14 67.9786 36.54 68.1536 35.565V34.19C67.5036 33.94 66.6036 33.765 65.7286 33.765C64.5786 33.765 63.6786 34.49 63.6786 35.49C63.6786 36.49 64.4786 37.14 65.6036 37.14Z",
    fill: "url(#paint4_linear_2_676)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_676",
    x1: 36.1489,
    y1: 39.74,
    x2: 36.1489,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_676",
    x1: 36.1489,
    y1: 39.74,
    x2: 36.1489,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_676",
    x1: 36.1489,
    y1: 39.74,
    x2: 36.1489,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_676",
    x1: 36.1489,
    y1: 39.74,
    x2: 36.1489,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_676",
    x1: 36.1489,
    y1: 39.74,
    x2: 36.1489,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusiveMedia);
export default __webpack_public_path__ + "static/media/Infusive Media.b5edbc31ad3533a4c6ca464161ef6861.svg";
export { ForwardRef as ReactComponent };